<template>
  <div v-if="main_info" class="client_info">
    <div class="client_info__left">
      <div class="block_wrap">
        <div class="row">
          <div class="col-md-4">
            <fg-input
                v-model="main_info.name"
                type="text"
                :label="translate('client.main_info.name')"
            />
          </div>

          <div class="col-md-4">
            <label>
              {{ translate('client.parent_company') }}
            </label>
            <tree-select
                :options="client_list"
                :placeholder="translate('client.parent_company')"
                v-model="main_info.parent_client_id"
                :clearable="false"
                :multiple="false"
                :disabled="!$store.getters.getPermissions.editClientParent === true"
            />
          </div>

          <div class="col-md-2">
            <label>
              {{ translate('client.main_info.edo_type') }}
            </label>
            <tree-select
                :options="edo_list"
                :placeholder="translate('client.main_info.edo_type')"
                v-model="main_info.edo_id"
                :clearable="false"
                :multiple="false"
            />
          </div>

          <div class="col-md-2">
            <div class="filter checkbox">
              <div class="info">
                {{ active ? translate('client.active') : translate('client.inactive')}}
              </div>
              <label class="switch" @click.prevent="active = !active">
                <input type="checkbox" v-model="active">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
                v-model="main_info.ur_name"
                type="text"
                :label="translate('client.main_info.ur_name')"
            />
          </div>
          <div class="col-md-3">
            <fg-input
                v-model="main_info.city"
                type="text"
                :label="translate('client.main_info.city')"
            />
          </div>
          <div class="col-md-3">
            <fg-input
                v-model="main_info.inn"
                type="text"
                :label="translate('client.main_info.inn')"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 text_wrap">
            <div class="form-group">
              <label>{{ translate('client.add_info.legal_address') }}</label>
              <textarea :rows="rows_3" class="input_text" name="name" v-model="main_info.legal_address" />
            </div>
          </div>
          <div class="col-md-6 text_wrap">
            <div class="form-group">
              <label>{{ translate('client.add_info.mailing_address') }}</label>
              <textarea :rows="rows_3" class="input_text" v-model="main_info.mailing_address" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 text_wrap">
            <div class="form-group">
              <label>{{ translate('client.add_info.bank_details') }}</label>
              <textarea :rows="rows_5" class="input_text" name="name" v-model="main_info.bank_details"/>
            </div>
          </div>
          <div class="col-md-6 text_wrap">
            <div class="form-group">
              <label>{{ translate('client.add_info.contacts') }}</label>
              <textarea :rows="rows_5" class="input_text"  v-model="main_info.contacts" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text_wrap">
            <div class="form-group">
              <label>{{ translate('client.main_info.descr') }}</label>
              <textarea :rows="rows_5_descr" class="input_text" name="name" v-model="main_info.descr"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <fg-input
                v-model="main_info.report_template_filename"
                type="text"
                :label="translate('client.report_template_filename')"
            />
          </div>
        </div>

        <div class="line" v-if="has_changes">
          <div class="button_wrap">
            <button
                class="btn btn-success btn-fill btn-wd"
                @click.prevent="edit_clients"
            >
              {{ translate("btn.edit") }}
            </button>
          </div>
        </div>

      </div>
    </div>
    <div class="client_info__right">
      <Summary type="client" :info="client_info" :view_history="false" />
    </div>
  </div>

</template>
<script>
import Summary from "components/UIComponents/Summary/Summary.vue";

const fields_to_check = [
  "name",
  "parent_client_id",
  "ur_name",
  "city",
  "inn",
  "legal_address",
  "mailing_address",
  "bank_details",
  "contacts",
  "descr",
  "edo_id",
  "active",
  "report_template_filename"
];

export default {
  name: 'ClientInfo',
  components: {Summary},
  props: ['client_info'],

  data () {
    return {
      main_info: {},
      active: true,
      use_diadoc: false,
      new_device_group: true,
      new_device_simcard_group: true
    }
  },
  computed:{
    rows_3(){
      return this.main_info.legal_address || this.main_info.mailing_address ? '3' : '1'
    },
    rows_5(){
      return this.main_info.bank_details || this.main_info.contacts ? '5' : '1'
    },
    rows_5_descr(){
      return this.main_info.descr ? '5' : '1'
    },
    edo_list(){
      return this.$store.getters.getClientEdoSystems.map((system) => {
        return { id: system.id, label: system.title }
      })
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        if (client.active !== 0){
          return { id: client.id, label: client.name }
        }
      }).filter((element) => { return element !== undefined })
    },
    has_changes() {
      let main_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.main_info[key];
        return obj;
      }, {});

      let client_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.client_info[key];
        return obj;
      }, {});

      return JSON.stringify(main_info) !== JSON.stringify(client_info);
    }
  },
  created() {
    this.main_info = Object.assign({}, this.client_info)
    this.active = !Object.keys(this.main_info).length > 0 ? true : this.main_info.active === 1
    this.use_diadoc = !Object.keys(this.main_info).length > 0 ? true : this.main_info.use_diadoc === 1

  },
  watch:{
    client_info(){
      this.main_info = Object.assign({}, this.client_info)
      this.active = !Object.keys(this.main_info).length > 0 ? true : this.main_info.active === 1
      this.use_diadoc = !Object.keys(this.main_info).length > 0 ? true : this.main_info.use_diadoc === 1
    },
    active(){
      this.main_info.active  = this.active ? 1 : 0
    },
    use_diadoc(){
      this.main_info.use_diadoc = this.use_diadoc ? 1 : 0
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    edit_clients(){
      let client_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.main_info[key];
        return obj;
      }, {});

      this.$http.v1.updateClient(this.main_info.id, client_info, (response) => {
        this.$emit('update_client', response.data)
        this.global_notify('info', this.translate('client.saved_success'))
        this.$store.dispatch('clientsListUpdate')
      })
    }
  }
}

</script>

<style lang='scss' scoped>

.client_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    margin-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    .block_wrap{
      text-align: left;
      //.line{
      //  display: flex;
      //  justify-content: space-between;
      //  align-items: flex-end;
      //  text-align: left;
      //  margin-bottom: 10px;
      //  .flex2{
      //    flex: 2;
      //  }
      //  .flex1{
      //    flex: 1;
      //  }
      //  .filter{
      //    min-width: 100px;
      //    text-align: center;
      //    margin: 0;
      //  }
      //  .form-group{
      //    margin: 0;
      //  }
      //  .text_wrap{
      //    width: 100%;
      //    margin: 2.5px;
      //  }
      //  .button_wrap{
      //    width: 100%;
      //    text-align: right;
      //  }
      //}
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}

</style>

